import {FC, memo, useEffect, useState} from "react";
import {Button, Container, Field, Heading, Input, Spinner, Text, VStack} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {ApiClient} from "../models/ApiClient";

type Props = {

}

class MessageState {
    message: string;
    color: string;

    private constructor(message: string, color: string) {
        this.message = message;
        this.color = color;
    }

    public isOk(): boolean {
        return this.color === "green";
    }

    public static default() {
        return new MessageState("", "");
    }

    public static error(message: string) {
        return new MessageState(message, "red");
    }

    public static ok(message: string) {
        return new MessageState(message, "green");
    }
}

enum SignInState {
    Fetch,
    NotSignIn,
    SignIn,
}

export const Activation: FC<Props> = memo((props) => {
    const {t} = useTranslation();

    const [signInState, setSignInState] = useState(SignInState.Fetch);

    const [code, setCode] = useState("");
    const [resultMessage, setResultMessage] = useState(MessageState.default());

    const signInApple = () => {
        window.location.href = ApiClient.getSignInAppleUrl();
    };
    const signInGoogle = () => {
        window.location.href = ApiClient.getSignInGoogleUrl();
    };
    const signOut = () => {
        window.location.href = ApiClient.getSignOutUrl();
    }
    const submitCode = async () => {
        if (!code) {
            setResultMessage(MessageState.error(t("activation.status.empty")));
            return;
        }

        const isActive = await ApiClient.sendActivationCode(code);
        setResultMessage(isActive ? MessageState.ok(t("activation.status.ok")) : MessageState.error(t("activation.status.error")))
    };

    useEffect(() => {
        let isMounted = true;
        (async () => {
            const isSignIn = await ApiClient.isSignIn();
            if (isMounted) {
                setSignInState(isSignIn ? SignInState.SignIn : SignInState.NotSignIn);
            }
        })();

        return () => {
            isMounted = false;
        }
    }, []);

    switch (signInState) {
        case SignInState.Fetch:
            return (
                <Container pt="5">
                    <Heading size="xl">{t("activation.title")}</Heading>

                    <Spinner />
                </Container>
            )
        case SignInState.SignIn:
            return (
                <Container pt="5">
                    <Heading size="xl">{t("activation.title")}</Heading>

                    {
                        (
                            resultMessage.isOk() ?
                            (
                                <Text mt="5" color={resultMessage.color}>{resultMessage.message}</Text>
                            ) :
                            (
                                <Container mt="5">
                                    <Field.Root required>
                                        <Field.Label>
                                            {t("activation.input.code.label")}
                                        </Field.Label>
                                        <Input placeholder={t("activation.input.code.placeholder")} value={code} onChange={(ev) => setCode(ev.target.value)} />
                                    </Field.Root>

                                    <Text color={resultMessage.color}>{resultMessage.message}</Text>
                                    <Button mt="5" colorPalette="blue" onClick={submitCode}>{t("activation.activate")}</Button>
                                </Container>
                            )
                        )
                    }

                    <Container mt="20">
                        <Button colorPalette="red" onClick={signOut}>{t("activation.signout")}</Button>
                    </Container>
                </Container>
            )
        case SignInState.NotSignIn:
            return (
                <Container pt="5">
                    <Heading size="xl">{t("activation.title")}</Heading>

                    <VStack mt="5">
                        <Button size="xl" colorPalette="blue" onClick={signInApple}>{t("activation.signin.apple")}</Button>
                        <Button mt="5" size="xl" colorPalette="blue" onClick={signInGoogle}>{t("activation.signin.google")}</Button>
                    </VStack>
                </Container>
            )
    }
});